var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"wave animation-patch",class:_vm.classes,attrs:{"viewBox":`0 0 ${_vm.width} ${_vm.height}`,"preserveAspectRatio":"none"}},[_c('path',{attrs:{"fill":_vm.color,"d":_vm.path}})])
}
var staticRenderFns = []

export { render, staticRenderFns }